import { usePostFlowContext } from "@/components/PostDialogs/SharedPostFlowContext";
import React from "react";
import { CaptionCoach } from "@/components";

export function CaptionCoachStep() {
  const { media, setPendingCaption, setBlockedWords, initialScript, setFlaggedWords } = usePostFlowContext();

  const firstTranscript = media.filter(m => m.category === "VIDEO").map(m => m.transcripts?.[0])[0]?.content;

  const context = firstTranscript || initialScript;
  const contextType = firstTranscript ? "video transcript" : "video script";

  return (
    <CaptionCoach
      handlePrediction={setPendingCaption}
      handleBlockedWords={setBlockedWords}
      handleFlaggedWords={setFlaggedWords}
      context={context}
      contextType={contextType}
    />
  );
}
